<div
  class="d-flex flex-column bgi-no-repeat rounded-top"
>
  <ul class="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">
    <li
      *ngIf="showAccountTypeSwitcher$ | async"
      class="nav-item"
    >
      <a
        class="
          nav-link
          text-dark
          opacity-75 opacity-state-100
          pb-4
          cursor-pointer
        "
        data-bs-toggle="tab"
        [ngClass]="activeTabId === 'account-switcher-tab-1' ? 'active' : ''"
        (click)="setActiveTabId('account-switcher-tab-1')"
      >
        {{ 'COMMON.ACCOUNT_TYPE_SHOP' | translate }}
      </a>
    </li>

    <li
      *ngIf="showAccountTypeSwitcher$ | async"
      class="nav-item"
    >
      <a
        class="
          nav-link
          text-dark
          opacity-75 opacity-state-100
          pb-4
          cursor-pointer
        "
        data-bs-toggle="tab"
        [ngClass]="activeTabId === 'account-switcher-tab-2' ? 'active' : ''"
        (click)="setActiveTabId('account-switcher-tab-2')"
      >
        {{ 'COMMON.ACCOUNT_TYPE_ADVERTISER' | translate }}
      </a>
    </li>
  </ul>
</div>

<div class="tab-content">
  <div class="mt-5 px-8 form-group has-search">
    <span class="fa fa-search form-control-feedback"></span>
    <input type="text" class="form-control" [placeholder]="'COMMON.SEARCH'|translate" [(ngModel)]="searchQuery">
  </div>

  <div
    class="tab-pane fade"
    id="kt_topbar_notifications_1"
    role="tabpanel"
    [ngClass]="activeTabId === 'account-switcher-tab-1' ? 'show active' : ''"
  >
    <div 
      *ngIf="publisherAclService.canSeeShops$ | async"
      class="scroll-y mh-325px my-5 px-8"
    >
      <ng-container
        *ngIf="(accountsService.publishers$ | async | appNotificationsInnerSearch:searchQuery) as publisherAccountsList"
      >
        <div
          *ngFor="let shop of publisherAccountsList"
          class="py-4"
        >
          <div class="mb-0 me-2">
            <a
              (click)="changeAccount(shop.id, 'shop')"
              class="fs-6 text-gray-800 text-hover-primary fw-bolder cursor-pointer d-block"
            >
              {{ shop.name }}
            </a>
            <div class="text-gray-400 fs-7">{{ shop.domain }}</div>
          </div>
        </div>
        <ng-container *ngIf="publisherAccountsList.length < 1" [ngTemplateOutlet]="noItemsFound"></ng-container>
      </ng-container>

    </div>

    <div
      *ngIf="!whiteLabelService.isWhiteLabel"
      class="py-3 text-center border-top"
    >
      <a
        *ngIf="publisherAclService.canManageShops$ | async"
        (click)="openModal(accountType.PUBLISHER)"
        class="btn btn-primary btn-sm"
      >
        {{ 'COMMON.ADD_NEW_SHOP' | translate }}
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr064.svg'"
          class="svg-icon svg-icon-5"
        ></span>
      </a>
    </div>
  </div>

  <div
    class="tab-pane fade"
    id="kt_topbar_notifications_2"
    role="tabpanel"
    [ngClass]="activeTabId === 'account-switcher-tab-2' ? 'show active' : ''"
  >
    <div
      *ngIf="advertiserAclService.canSeeAdvertisers$ | async"
      class="scroll-y mh-325px my-5 px-8"
    >
      <ng-container
        *ngIf="(accountsService.advertisers$ | async | appNotificationsInnerSearch:searchQuery) as advertiserAccountsList"
      >
        <div
          *ngFor="let adv of advertiserAccountsList"
          class="py-4"
        >
          <a (click)="changeAccount(adv.id, 'advertiser')"
              class="fs-6 text-gray-800 text-hover-primary fw-bolder cursor-pointer d-block">
            {{ adv.name }}
          </a>
          <div class="text-gray-400 fs-7">{{ adv.domain }}</div>
        </div>
        <ng-container *ngIf="advertiserAccountsList.length <1" [ngTemplateOutlet]="noItemsFound"></ng-container>
      </ng-container>
    </div>
    <div
      *ngIf="!whiteLabelService.isWhiteLabel"
      class="py-3 text-center border-top"
    >
      <a
        *ngIf="advertiserAclService.canManageAdvertisers$ | async"
        (click)="openModal(accountType.ADVERTISER)"
        class="btn btn-primary btn-sm"
      >
        {{ 'COMMON.ADD_NEW_ADVERTISER' | translate }}
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr064.svg'"
          class="svg-icon svg-icon-5"
        ></span>
      </a>
    </div>
  </div>
  <ng-template #noItemsFound>
    <div class="py-4 px-3 bg-light text-inverse-light rounded fw-bold">
      {{ 'ACCOUNT_SWITCHER.NO_RESULTS' | translate }}
    </div>
  </ng-template>
</div>
